import React, { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/contexts/LanguageContext";
import WithdrawMessage from "./WithdrawMessage";
export default function AuthoredMessages() {
  const { lang } = useI18n(); const it=lang==='it';
  const [items,setItems]=useState([]), [cursor,setCursor]=useState(null);
  const [busy,setBusy]=useState(false), [error,setError]=useState(false);
  const live=useRef(true), pending=useRef(false), retired=useRef(new Set());
  const load=async (before=null)=>{
    if(pending.current)return;pending.current=true;setBusy(true);setError(false);
    try {
      const {data}=await api.get('/account/messages/authored',{params:{limit:30,...(before?{before}:{})}});
      if(live.current){
        const rows=data.items.map(m=>retired.current.has(m.id)?{...m,body:null,content_removed:true,withdrawal_status:'pending_review'}:m);
        setItems(old=>before?[...old,...rows.filter(m=>!old.some(o=>o.id===m.id))]:rows);setCursor(data.next_cursor);
      }
    }catch{if(live.current)setError(true);}
    finally{pending.current=false;if(live.current)setBusy(false);}
  };
  useEffect(()=>{live.current=true;load();return()=>{live.current=false;};},[]);
  return <section className="nvl-card p-5 mb-6" aria-label={it?'I miei messaggi':'My messages'}>
    <h2>{it?'I miei messaggi':'My messages'}</h2>
    <p>{it?'Puoi ritirare anche i contenuti delle conversazioni chiuse. Qui compaiono soltanto i messaggi inviati da te.':'You can also withdraw content from closed conversations. Only messages you sent are listed here.'}</p>
    {error&&<p role="alert">{it?'Elenco non disponibile. Riprova.':'List unavailable. Please retry.'}</p>}
    {!busy&&!error&&!items.length&&<p>{it?'Nessun messaggio disponibile.':'No messages available.'}</p>}
    <ul>{items.map(m=><li key={m.id} className="border-b py-3">
      <p>{m.created_at} · {m.kind==='photo'?(it?'Foto':'Photo'):m.kind==='voice'?(it?'Audio':'Voice'):(it?'Testo':'Text')}</p>
      <p className="whitespace-pre-wrap break-words">{m.content_removed?(m.withdrawal_status==='erased'?(it?'Contenuto cancellato.':'Content erased.'):(it?'Contenuto ritirato o non disponibile.':'Content withdrawn or unavailable.')):m.body}</p>
      {m.withdrawal_status==='pending_review'&&<p>{it?'Verifica della conservazione in attesa.':'Retention review pending.'}</p>}
      <WithdrawMessage message={m} onWithdrawn={id=>{retired.current.add(id);setItems(old=>old.map(x=>x.id===id?{...x,body:null,content_removed:true,withdrawal_status:'pending_review'}:x));}}/>
    </li>)}</ul>
    {busy&&<p role="status">{it?'Caricamento…':'Loading…'}</p>}
    {(cursor||error)&&<button type="button" disabled={busy} onClick={()=>load(cursor)}>{error?(it?'Riprova':'Retry'):(it?'Carica altri':'Load more')}</button>}
  </section>;
}
